import { UserTag } from '@kcftech/prometheus-client';
import { useQuery } from '@tanstack/react-query';
import { sdClient } from 'contexts/SDKClientContext';
import { useCallback } from 'react';
import { serializeMention } from 'shared/content_editable/shared';

export const DESK_CHAT_DISPLAY_NAME = 'Resolve';

async function fetchDeskChatUserIds(): Promise<ReadonlySet<string>> {
    const response = await sdClient.getUserIdsByTag({ tag: UserTag.DeskChat });
    return new Set(response);
}

const deskChatUserIdsQueryOptions = {
    queryKey: ['deskChatUserIds'],
    queryFn: fetchDeskChatUserIds,
    gcTime: Infinity,
    staleTime: Infinity,
} as const;

export function useDeskChatMentionText(): string | undefined {
    const { data } = useQuery(deskChatUserIdsQueryOptions);
    const userId = data?.values().next().value;
    return userId ? serializeMention(userId) : undefined;
}

export function useIsDeskChatUser(): (userId: string | undefined) => boolean {
    const { data: userIds } = useQuery(deskChatUserIdsQueryOptions);

    return useCallback(
        (userId: string | undefined) => !!userId && !!userIds?.has(userId),
        [userIds],
    );
}
